import React, { useEffect, useState } from "react";
import HeroSection from "../components/home/HeroSection";
import EventStrip from "../components/home/EventStrip";
import LatestEvents from "../components/home/LatestEvents";
import AboutUs from "../components/home/AboutUs";
import Team from "../components/home/Team";
import EventGallery from "../components/home/EventGallery";
import Sponsors from "../components/home/Sponsors";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";

function Home() {
  const [bannerData, setBannerData] = useState(null);
  const [upcomingEvents, setUpcomingEvents] = useState(null);

  const [otherDetails, setOtherDetails] = useState({
    aboutUs: null,
    committeeList: null,
    sponsorList: null,
    upcomingEvents: null,
    // eventGalleryList: null
  });

  const [loading, setLoading] = useState(false);

  const fetchBannerData = async () => {
    try {
      setLoading(true);
      const response = await API.get(api_paths.member.HOME.GET_BANNER);

      const data = response.data?.payload?.result?.data || null;
      setBannerData(data);
      // console.log("Banner Data:", response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching banner data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  const fetchUpcomingEvents = async () => {
    try{
      setLoading(true);
      const response = await API.get(api_paths.member.HOME.GET_UPCOMING_EVENTS);
      const data = response.data?.payload?.result?.data || null;
      setUpcomingEvents(data);
      // console.log("Upcoming events data: ", response.data);
      setLoading(false);
    }catch(error) {
      console.error("Error fetching banner data:", error);
      setLoading(false);
    } finally{
      setLoading(false);
    }
  }

  const fetchOtherDetails = async () => {
    try{
      setLoading(true);
      const response = await API.get(api_paths.member.HOME.GET_OTHER_DETAILS);
      // console.log("Other home details data: ", response.data);
      const aboutUs = response.data?.payload?.result?.aboutUs || null;
      const committeeList = response.data?.payload?.result?.committeeList || null;
      const sponsorList = response.data?.payload?.result?.sponsorList || null;
      const upcomingEvents = response.data?.payload?.result?.upcomingEvents || null;
      // const eventGalleryList = response.data?.payload?.result?.eventGalleryList || null;
      setOtherDetails({
        aboutUs,
        committeeList,
        sponsorList,
        upcomingEvents,
        // eventGalleryList
      });
      // console.log("Upcoming events data: ", response.data);
      setLoading(false);
    }catch(error) {
      console.error("Error fetching banner data:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchBannerData();
    fetchUpcomingEvents();
    fetchOtherDetails();
  }, []);


  return (
    <>
      <section>
        <div className="container">
          <HeroSection bannerData={bannerData} loading={loading} />
          <EventStrip upcomingEvents={upcomingEvents} loading={loading}/>
          <LatestEvents nextMonthUpcomingEvents={otherDetails.upcomingEvents} loading={loading}/>
          <AboutUs aboutUs={otherDetails.aboutUs}/>
          <Team committeeList={otherDetails.committeeList}/>
          {/* <EventGallery eventGalleryList={otherDetails.eventGalleryList} loading={loading}/> */}
          <EventGallery/>
          <Sponsors sponsorList={otherDetails.sponsorList}/>
        </div>
      </section>
    </>
  );
}

export default Home;
